const SPLIT_REGEXP = /[ ;,]/; // Non-greedy, less backtracking

export const convertSearchQuery = (searchQuery: string): string[] => {
  let serialNumbers: string[] = [];

  if (searchQuery?.length > 0) {
    serialNumbers = searchQuery
      .trim() // to make sure start and end spaces are removed
      .split(SPLIT_REGEXP) // handles `;` or `,` or ` ` separators
      .filter(Boolean); // filter out ONLY actual values
  }

  const convertedValue = Array.isArray(serialNumbers) ? serialNumbers : [];

  return convertedValue;
};

const SEARCH_LIMIT_REGEXP = /^[a-zA-Z0-9-_,;()\s]*$/;
const SEARCH_LIMIT = 20;

export const isSearchQueryValueValid = (
  value: string,
  searchLimit = SEARCH_LIMIT
) => {
  const condition =
    SEARCH_LIMIT_REGEXP.test(value) &&
    convertSearchQuery(value).length <= searchLimit;

  return condition;
};
